import { DocumentEvaCompanyApparence, HTMLEntry } from "../../eva-company/domains/eva-company";

export class InvoicePdfConfig {
  contact_id = null;
  header_location = "";
  header_date = null;
  show_info_employee = true;
  show_info_project = true;
  show_info_offer = true;
  is_show_payment_deadline = true;
  show_info_customer = true;
  footerHTML: string;
  apparence: DocumentEvaCompanyApparence = new DocumentEvaCompanyApparence();
  isOriginalApparence: boolean = true;
  displaySignature: boolean = false;
  displayQuotationAsAnnex: boolean = false;
  annexes: HTMLEntry[] = [];
  title = "";
  headerHTML = "";
  outro_offerHTML = "";
  payment_conditions_html = "";
  closing_textHTML = "";
  pdfModel: string = "MODEL_1";
  logoSize: string = "80";
  recapAmountPageBreak: boolean = false;
  recapdetailedOfferPageBreak: boolean = false;
  offerPageBreak: boolean = false;
  recap_table_levels: number = 1;
  isShowsArticleNumber: boolean = false;
  isShowsDiscountValue: boolean = false;
  isShowsSellingPriceUnit: boolean = false;
  isShowsSellingPriceTotal: boolean = true;
  isShowsQuantity: boolean = false;
  isShowsSituation: boolean = false;
  showRecapFirst: boolean = false;

  constructor() {
    this.contact_id = null;
    this.header_location = "";
    this.header_date = null;
    this.show_info_employee = true;
    this.show_info_project = true;
    this.show_info_offer = true;
    this.is_show_payment_deadline = true;
    this.show_info_customer = true;
    this.isOriginalApparence = true;
    this.displaySignature = false;
    this.displayQuotationAsAnnex = false;
    this.title = "";
    this.headerHTML = "";
    this.outro_offerHTML = "";
    this.closing_textHTML = "";
    this.apparence = new DocumentEvaCompanyApparence();
    this.pdfModel = "MODEL_1";
    this.logoSize = "logoSize";
  }

  public static createInstance(jsonData: any): InvoicePdfConfig {
    const instance = new InvoicePdfConfig();

    for (const key in jsonData) {
      if (jsonData[key] !== null && jsonData[key] !== undefined) {
        instance[key] = jsonData[key];
      }
    }

    if (instance.header_date) {
      instance.header_date = new Date(instance.header_date);
    }
    instance.apparence = DocumentEvaCompanyApparence.createInstance(jsonData.apparence || {});
    instance.annexes = (jsonData.annexes || []).map((a: any) => HTMLEntry.createInstance(a));
    return instance;
  }
}
